import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { GenerateDataKeyPair$ } from "../schemas/schemas_0";
export { $Command };
export class GenerateDataKeyPairCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("TrentService", "GenerateDataKeyPair", {})
    .n("KMSClient", "GenerateDataKeyPairCommand")
    .sc(GenerateDataKeyPair$)
    .build() {
}
